import { Client } from "../api/Client";
import { useQuery } from "@tanstack/react-query";

export const useGetBrands = (
  countryId: number | undefined,
  languageId: number | undefined
) => {
  const client = new Client();
  return useQuery({
    queryKey: ["getBrands", countryId, languageId],
    queryFn: () => client.brands(countryId ?? 0, languageId ?? 0),
    staleTime: 1000 * 60 * 60,
  });
};
